// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import './plugins/axios'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import App from './App'
import store from './store'
import router from './router'
import './icons' // icon
import './plugins/element.js'
import '@/styles/style.scss'

import Meta from 'vue-meta'
Vue.use(Meta)

Vue.config.productionTip = false
Vue.prototype.textareaFilter= function (str) {
  // to do
  return str.replace(/\n|\r\n/g, '<br>')
 };
 Vue.prototype.brTopFilter= function (str) {
  // to do
  return str.replace(/<br \/>/g, '</p><p>')
 };
 Vue.prototype.titleFilter= function (str) {
  let num = str.lastIndexOf("-")
  if(num > 0){
    return str.substr(num+1);
  } else {
    return str;
  }
 };
 

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js